/* eslint-disable */
export default {
  name: 'header-before-login',
  components: {},
  props: [],
  data() {
    return {
      showLogin: true
    }
  },
  computed: {

  },
  mounted() {
  },
  methods: {}
}